<template>
  <div>
    <file-up-load
      :editInfo="params"
      :applyType="$route.query.applyType"
      v-if="news=='ai'"
      :news="news"
    ></file-up-load>
    <file-up-load1
      :editInfo="params"
      :applyType="$route.query.applyType"
      v-else
      :news="news"
    ></file-up-load1>
  </div>
</template>

<script>
import { postAction, putAction, fileUpdate, getAction } from "@/api/index";
import fileUpLoad from "../../components/educationalBrandFileupload1/index2.vue";
import fileUpLoad1 from "../../components/educationalBrandFileupload/index2.vue";
export default {
  name: "",
  components: {
    fileUpLoad,
    fileUpLoad1
  },
  props: {},
  data() {
    return {
      params: null,
      id: "",
      news:'add',
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted(){
    //  console.log("2222",window.sessionStorage.getItem(`step${this.$store.state.user.id}`),this.$route.query.id);
     if(this.$route.query.new){
        this.news=this.$route.query.new;
    }
    if(this.$route.query.id){
      this.id=this.$route.query.id;
      window.sessionStorage.setItem(`step${this.$store.state.user.id}`,this.id);
      this.getQueryId();
    }else if(window.sessionStorage.getItem(`step${this.$store.state.user.id}`)){
      this.id=window.sessionStorage.getItem(`step${this.$store.state.user.id}`);
      this.getQueryId();
    }else{
      this.id='';
      this.params=null;
    }
   
  },
  methods: {
    getQueryId() {
      let data = {
        id: this.id,
      };
      getAction("/lx/lxApply/queryById", data).then((res) => {
        if (res.code === 200) {
          const result = res.result || {};
          // 预览/审核查看进入：标记只读，子组件据此禁用全部字段
          if (
            this.news === "preview" ||
            this.news === "audit" ||
            this.$route.query.new === "preview" ||
            this.$route.query.new === "audit"
          ) {
            result.type = "preview";
          }
          this.params = result;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
